import React, {useState} from 'react';
import {
  AppstoreOutlined,
  MailOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import type {MenuProps} from 'antd';
import {Menu} from 'antd';

type ReportHeaderProps = {
  onSwitch: (key: string) => void;
};

export const ReportHeader = ({
  onSwitch,
}: ReportHeaderProps) => {
  type MenuItem = Required<MenuProps>['items'][number];

  const items: MenuItem[] = [
    {
      label: 'Report',
      key: 'report',
      icon: <MailOutlined />,
    },
    {
      label: 'Placement tests',
      key: 'placementTests',
      icon: <MailOutlined />,
    },
  ];
  const [current, setCurrent] = useState<'report' | 'placementTests'>('report');

  const onClick: MenuProps['onClick'] = (e) => {
    // @ts-ignore
    setCurrent(e.key);
    onSwitch(e.key);
  };

  return (
    <Menu
      onClick={onClick}
      selectedKeys={[current]}
      mode="horizontal"
      items={items}
    />
  );
};
